import moment from "moment";
import momentCustom from "@/common/languages/moment";

const FORMAT_DEFAULT = "YYYY-MM-DD";

export class DateTimeFormatHelper {
  static Format(dateTime: Date = new Date(), format = FORMAT_DEFAULT): string {
    let formatClone = format;
    // use letter a instead of tt to indicate AM/PM
    if(formatClone.includes("tt")) {
      formatClone = formatClone.replace("tt", "a");
    }
    return momentCustom(dateTime).format(formatClone);
  }

  static FormatByCulture(
    dateTime: Date = new Date(),
    format: string | undefined = FORMAT_DEFAULT,
  ): string {
    let formatClone = format;
    // use letter a instead of tt to indicate AM/PM
    if(formatClone.includes("tt")) {
      formatClone = formatClone.replace("tt", "a");
    }
    return momentCustom(dateTime).format(formatClone);
  }

  static convertStringToDateUTC(value: string | Date): Date {
    const dateFormat: Date = new Date(value);
    dateFormat.setHours(dateFormat.getUTCHours());
    return dateFormat;
  }

  private static MONTH_NAMES = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  private static DAY_NAMES = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
  ];
  private static MONTHS_SHORT = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // private static formatDate(date: Date = new Date(), format = FORMAT_DEFAULT) {
  //   format = format + "";
  //   let result = "";
  //   let i_format = 0;
  //   let c = "";
  //   let token = "";
  //   const y = date.getFullYear();
  //   const M = date.getMonth() + 1;
  //   const d = date.getDate();
  //   const E = date.getDay();
  //   const H = date.getHours();
  //   const m = date.getMinutes();
  //   const s = date.getSeconds();
  //   // Convert real date parts into formatted versions
  //   const value = new Object();

  //   value["y"] = "" + y;
  //   value["yyyy"] = y;
  //   value["yy"] = y.toString().substring(2, 4);
  //   value["M"] = M;
  //   value["MM"] = DateTimeFormatHelper.LZ(M);
  //   value["MMM"] = DateTimeFormatHelper.MONTH_NAMES[M - 1];
  //   value["MMMM"] = DateTimeFormatHelper.MONTH_NAMES[M - 1];
  //   value["NNN"] = DateTimeFormatHelper.MONTH_NAMES[M + 11];
  //   value["d"] = d;
  //   value["dd"] = DateTimeFormatHelper.LZ(d);
  //   value["E"] = DateTimeFormatHelper.DAY_NAMES[E + 7];
  //   value["EE"] = DateTimeFormatHelper.DAY_NAMES[E];
  //   value["H"] = H;
  //   value["HH"] = DateTimeFormatHelper.LZ(H);
  //   if (H == 0) {
  //     value["h"] = 12;
  //   } else if (H > 12) {
  //     value["h"] = H - 12;
  //   } else {
  //     value["h"] = H;
  //   }
  //   value["hh"] = DateTimeFormatHelper.LZ(value["h"]);
  //   if (H > 11) {
  //     value["K"] = H - 12;
  //   } else {
  //     value["K"] = H;
  //   }
  //   value["k"] = H + 1;
  //   value["KK"] = DateTimeFormatHelper.LZ(value["K"]);
  //   value["kk"] = DateTimeFormatHelper.LZ(value["k"]);
  //   if (H > 11) {
  //     value["a"] = "PM";
  //   } else {
  //     value["a"] = "AM";
  //   }
  //   value["m"] = m;
  //   value["mm"] = DateTimeFormatHelper.LZ(m);
  //   value["s"] = s;
  //   value["ss"] = DateTimeFormatHelper.LZ(s);
  //   while (i_format < format.length) {
  //     c = format.charAt(i_format);
  //     token = "";
  //     while (format.charAt(i_format) == c && i_format < format.length) {
  //       token += format.charAt(i_format++);
  //     }
  //     if (value[token] != null) {
  //       result = result + value[token];
  //     } else {
  //       result = result + token;
  //     }
  //   }
  //   return result;
  // }

  // private static formatDateLocale(date: Date = new Date(), format = FORMAT_DEFAULT, locale) {
  //   DateTimeFormatHelper.MONTHS_SHORT = locale?.MONTHS_SHORT || [];
  //   DateTimeFormatHelper.MONTH_NAMES = locale?.MONTHS || [];
  //   DateTimeFormatHelper.DAY_NAMES = locale?.WEEKDAYS_LONG || [];
  //   format = format + "";
  //   let result = "";
  //   let i_format = 0;
  //   let c = "";
  //   let token = "";
  //   const y = date.getFullYear();
  //   const M = date.getMonth() + 1;
  //   const d = date.getDate();
  //   const E = date.getDay();
  //   const H = date.getHours();
  //   const m = date.getMinutes();
  //   const s = date.getSeconds();
  //   // Convert real date parts into formatted versions
  //   const value = new Object();

  //   value["y"] = "" + y;
  //   value["yyyy"] = y;
  //   value["yy"] = y.toString().substring(2, 4);
  //   value["M"] = M;
  //   value["MM"] = DateTimeFormatHelper.LZ(M);
  //   value["MMM"] = DateTimeFormatHelper.MONTHS_SHORT[M - 1];
  //   value["MMMM"] = DateTimeFormatHelper.MONTH_NAMES[M - 1];
  //   value["NNN"] = DateTimeFormatHelper.MONTH_NAMES[M + 11];
  //   value["d"] = d;
  //   value["dd"] = DateTimeFormatHelper.LZ(d);
  //   value["E"] = DateTimeFormatHelper.DAY_NAMES[E + 7];
  //   value["EE"] = DateTimeFormatHelper.DAY_NAMES[E];
  //   value["H"] = H;
  //   value["HH"] = DateTimeFormatHelper.LZ(H);
  //   if (H == 0) {
  //     value["h"] = 12;
  //   } else if (H > 12) {
  //     value["h"] = H - 12;
  //   } else {
  //     value["h"] = H;
  //   }
  //   value["hh"] = DateTimeFormatHelper.LZ(value["h"]);
  //   if (H > 11) {
  //     value["K"] = H - 12;
  //   } else {
  //     value["K"] = H;
  //   }
  //   value["k"] = H + 1;
  //   value["KK"] = DateTimeFormatHelper.LZ(value["K"]);
  //   value["kk"] = DateTimeFormatHelper.LZ(value["k"]);
  //   if (H > 11) {
  //     value["a"] = locale.PM;
  //   } else {
  //     value["a"] = locale.AM;
  //   }
  //   value["m"] = m;
  //   value["mm"] = DateTimeFormatHelper.LZ(m);
  //   value["s"] = s;
  //   value["ss"] = DateTimeFormatHelper.LZ(s);
  //   while (i_format < format.length) {
  //     c = format.charAt(i_format);
  //     token = "";
  //     while (format.charAt(i_format) == c && i_format < format.length) {
  //       token += format.charAt(i_format++);
  //     }
  //     if (value[token] != null) {
  //       result = result + value[token];
  //     } else {
  //       result = result + token;
  //     }
  //   }
  //   return result;
  // }

  static getPreviousAndNextDate(dateString: string) {
    let currentDate: Date;
    if (dateString.includes("-")) {
      const parts = dateString.split("-");
      const year = Number(parts[0]);
      const month = Number(parts[1]) < 10 ? "0" + parts[1] : parts[1];
      const day = Number(parts[2]) < 10 ? "0" + parts[2] : parts[2];
      const formattedDateString = year + "/" + month + "/" + day;
      currentDate = new Date(formattedDateString);
    } else {
      currentDate = new Date(dateString);
    }

    // Lấy ngày trước đó
    const previousDate = new Date(currentDate.getTime());
    previousDate.setDate(currentDate.getDate() - 1);
    const previousDateString = moment(previousDate)
      .format("YYYY-MM-DDTHH:mm:ss.000Z")
      .substr(0, 10);

    // Lấy ngày tiếp theo
    const nextDate = new Date(currentDate.getTime());
    nextDate.setDate(currentDate.getDate() + 1);
    const nextDateString = moment(nextDate)
      .format("YYYY-MM-DDTHH:mm:ss.000Z")
      .substr(0, 10);

    return {
      previousDate: previousDateString,
      nextDate: nextDateString,
    };
  }

  static isEveningMidnight(dateTime: Date) {
    return (
      dateTime.getHours() === 0 &&
      dateTime.getMinutes() === 0 &&
      dateTime.getSeconds() === 0
    );
  }

  static isAllDay(startTime: Date, endTime: Date): boolean {
    // Chuyển đổi thời gian đầu vào thành đối tượng Date
    const startDate = new Date(startTime).getTime();
    const endDate = new Date(endTime).getTime();

    // Tính độ chênh lệch giữa thời gian bắt đầu và kết thúc
    const duration = endDate - startDate;

    // Nếu độ chênh lệch là một ngày đầy đủ, thì sự kiện là cả ngày
    if (duration % 86400000 === 0) {
      // 86400000 milliseconds = 1 day
      return true;
    } else {
      return false;
    }
  }

  static convertStartAndEndTimeAllDayEvent(startTime: Date, endTime: Date, isRecurring?: boolean): {startTime: string; endTime: string} {
    if(!isRecurring) {
      return {
        startTime: moment(new Date(startTime)).format("YYYY-MM-DDT00:00:00"),
        endTime:  moment(new Date(endTime)).format("YYYY-MM-DDT00:00:00"),
      }
    } else {
      return {
        startTime: moment(new Date(startTime)).format("YYYY-MM-DDT00:00:00"),
        endTime:  moment(new Date(endTime)).format("YYYY-MM-DDT00:00:00"),
      }
    }
  }


  // static getFormattedTime(date, format) {
  //   //console.log(date,format);

  //   const hour = date.getHours();
  //   const minute = date.getMinutes();

  //   let formattedHour = hour.toString();

  //   let period = "";

  //   if (format.includes("h")) {
  //     if (hour > 12) {
  //       period = "PM";
  //     } else if (hour === 0) {
  //       formattedHour = "12";
  //       period = "AM";
  //     } else if (hour === 12) {
  //       formattedHour = "12";
  //       period = "PM";
  //     } else {
  //       period = "AM";
  //     }
  //   }

  //   let formattedMinute = minute.toString().padStart(2, "0");

  //   switch (format) {
  //     case "HH:mm":
  //       if (hour >= 0 && hour <= 9) {
  //         formattedHour = `0${hour}`;
  //       }
  //       return `${formattedHour}:${formattedMinute}`;
  //     case "hh:mm tt":
  //       if (hour >= 0 && hour <= 9) {
  //         formattedHour = `0${hour}`;
  //       }
  //       return `${formattedHour}:${formattedMinute} ${period}`;
  //     case "H:mm":
  //       return `${hour}:${formattedMinute}`;
  //     case "h:mm tt":
  //       return `${formattedHour}:${formattedMinute} ${period}`;
  //     default:
  //       return null;
  //   }
  // }
}
